import { Component, OnInit } from '@angular/core';
import { TranslationLoaderService } from '../service/translation-loader.service';
import { locale as english } from '../shared/i18n/en';
import { locale as french } from '../shared/i18n/fr';
@Component({
  selector: 'app-my-services',
  templateUrl: './my-services.component.html',
  styleUrls: ['./my-services.component.css'],

})
export class MyServicesComponent implements OnInit {

  services: any =  ["Web Development", "Custom Software Development","Web Design", "Saas Development", "Database Development", "Techical Customer Support", "IT Consulting", "Software Prototyping", "Microservices Development", "DevOps"  ]
  
  constructor(private _translationLoaderService: TranslationLoaderService) {
    this._translationLoaderService.loadTranslations(english, french);
  }

  ngOnInit(): void {
  }

}
